import React from 'react';
import './index.css'

const DataList = (props) => {
    return (
        <div className={`data-list border px-3 pb-3${props.className ? ' ' +props.className : ''} bg-white`}>
            {props.children}
        </div>
    );
};

export default DataList;